import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook } from 'react-icons/fa';
import { MdEventNote } from 'react-icons/md';
import { FiSend } from 'react-icons/fi';

import AfdImg from './img/parteners/afd.jpg';
import ForimImg from './img/parteners/forim.jpg';
import CosimImg from './img/parteners/cosim.jpg';
import FondationDevoTeamImg from './img/parteners/devoteam.png';
import GuildeImg from './img/parteners/guilde.png';
import MinistereEtrangeImg from './img/parteners/ministereAffaires.png';
import DepartementRhoneImg from './img/parteners/departementRhone.png';
import TchadImg from './img/parteners/tchad.jpg';

export const navData = {
  items: [
    { href: "#about", name: "Notre mission" },
    {
      name: "Projets",
      submenu: [
        { href: "#projet-kemkian", name: "Kemkian — Sarh" },
        { href: "#projet-modele", name: "Modelé — Canton" },
      ],
    },
    { href: "#events", name: "Actualités" },
    {
      name: "Galerie",
      submenu: [
        { href: "#gallery-kemkian", name: "Kemkian — Sarh" },
        { href: "#gallery-modele", name: "Modelé — Canton" },
      ],
    },
    { href: "#partners", name: "Partenaires" },
    { href: "#contact", name: "Contact" },
  ],
};

export const socialData = [
  { href: "https://www.facebook.com/", icon: <FaFacebook />, label: "Facebook" },
];

export const heroData = {
  eyebrow: "Association APPE Tchad · Depuis 2004",
  title: "Chaque enfant mérite une chance de grandir",
  subtitle: "La petite enfance et l’accès à l’éducation sont nos priorités.",
  btnPrimary: {
    text: "Faire un don",
    href: "https://www.helloasso.com/associations/association-des-professionnels-de-la-petite-enfance/collectes/aider-l-ecole-primaire-a-sarh-au-tchad-fonctionnement-achat-de-tables-bancs",
  },
  btnSecondary: { text: "Découvrir nos actions", href: "#about" },
};

export const impactData = [
  { value: 562, suffix: "+", label: "Élèves scolarisés" },
  { value: 2, suffix: "", label: "Écoles construites" },
  { value: 15, suffix: "+", label: "Enseignants formés" },
  { value: 20, suffix: " ans", label: "D’engagement au Tchad" },
];

export const partenerData = [
  { href: "https://www.afd.fr", logo: AfdImg, name: "Agence Française de Développement" },
  { href: "https://forim.net", logo: ForimImg, name: "FORIM — Diasporas solidaires" },
  {
    href: "https://france.devoteam.com/fondation-devoteam/",
    logo: FondationDevoTeamImg,
    name: "Fondation Devoteam",
  },
  {
    href: "https://www.coordinationsud.org/membre/cosim-rhone-alpes-collectif-des-organisations-de-solidarites-internationales-issues-des-migrations-de-la-region-rhone-alpes/",
    logo: CosimImg,
    name: "COSIM Rhône-Alpes",
  },
  {
    href: "https://www.agencemicroprojets.org/",
    logo: GuildeImg,
    name: "La Guilde — Agence des Micro-Projets",
  },
  {
    href: "https://www.diplomatie.gouv.fr/fr/",
    logo: MinistereEtrangeImg,
    name: "Ministère des Affaires Étrangères",
  },
  { href: "https://www.rhone.fr/", logo: DepartementRhoneImg, name: "Département du Rhône" },
  { href: "/", logo: TchadImg, name: "État Tchadien" },
];

export const eventsData = [
  {
    date: "2022",
    title: "Courses solidaires à Massy",
    location: "Collège Gérard PHILIPE — Massy 91300, France",
    description:
      "19 juin et 21 septembre 2022 : deux courses solidaires organisées par les élèves pour soutenir les enfants de Sarh. Récolte de 2 820 € de dons.",
    icon: <MdEventNote />,
  },
  {
    date: "Oct. 2022",
    title: "Événement APPE à Lyon",
    location: "Lyon, France",
    description:
      "29 octobre 2022 — Soirée de mobilisation ayant permis de récolter 1 398,50 € d’événementiel et 2 820 € de dons.",
    icon: <MdEventNote />,
  },
  {
    date: "Avr. 2019",
    title: "Course solidaire — 80 élèves",
    location: "Collège Gérard Philipe — Massy, France",
    description:
      "80 élèves participants, recette de 503 €. La course a été appréciée des élèves, professeurs et membres de l’association.",
    icon: <MdEventNote />,
  },
  {
    date: "Avr. 2018",
    title: "Soirée de gala — Villeurbanne",
    location: "Salle Rockamahjou — Villeurbanne, France",
    description:
      "Événement festif avec repas, tombola et soirée dansante organisé au profit de l’association.",
    icon: <MdEventNote />,
  },
  {
    date: "Oct. 2013",
    title: "Journée de rentrée",
    location: "Salle Maryse Bastié — Lyon 8ème, France",
    description:
      "Présentation du projet, vente de repas tchadien et français, loto, récolte de matériel de puericulture.",
    icon: <MdEventNote />,
  },
];

export const donateData = {
  eyebrow: "Agir concrètement",
  title: "Votre don change une vie",
  subtitle:
    "Chaque euro compte. Grâce à vous, nous pouvons construire des salles de classe, acheter du matériel pédagogique et offrir à ces enfants un avenir meilleur.",
  impacts: [
    { amount: 10, description: "Cahiers et stylos pour 5 élèves" },
    { amount: 30, description: "Un livre de lecture pour une classe" },
    { amount: 100, description: "Fournitures scolaires pour une classe" },
    { amount: 500, description: "Contribution à la construction d’une table-banc" },
  ],
  bankTransfer: {
    title: "Virement bancaire",
    name: "Association des Professionnels de la Petite Enfance",
    iban: "FR71 2004 1010 0714 2301 0Y03 895",
    bic: "PSSTFRPPLYO",
    note: "Merci d’indiquer « Don APPE » en référence de votre virement",
  },
  onlineLink: {
    text: "Faire un don en ligne",
    href: "https://www.helloasso.com/associations/association-des-professionnels-de-la-petite-enfance/collectes/aider-l-ecole-primaire-a-sarh-au-tchad-fonctionnement-achat-de-tables-bancs",
  },
};

export const contactData = {
  eyebrow: "Nous écrire",
  title: "Contactez-nous",
  info: [
    {
      title: "Siège social APPE",
      subtitle: "Association des Professionnels de la Petite Enfance",
      address: { icon: <FaMapMarkerAlt />, name: "4 allée George Sand, 91300 Massy, France" },
      phone: { icon: <FaPhoneAlt />, number: "+33 06 13 22 27 55" },
      email: { icon: <FaEnvelope />, address: "association.appe@yahoo.com" },
    },
    {
      title: "Partenaire local AME",
      subtitle: "Association Mère Enfant — Sarh",
      address: { icon: <FaMapMarkerAlt />, name: "Quartier Kemkian, Sarh, Tchad" },
      phone: { icon: <FaPhoneAlt />, number: "+235 95 73 94 24" },
      email: { icon: <FaEnvelope />, address: "association.appe@yahoo.com" },
    },
  ],
};

export const footerData = {
  description:
    "Depuis 2004, l’APPE Tchad œuvre pour l’éducation et la petite enfance dans les quartiers défavorisés du Tchad.",
  contacts: {
    address: { icon: <FaMapMarkerAlt />, name: "4 allée George Sand, 91300 Massy, France" },
    phone: { icon: <FaPhoneAlt />, number: "+33 06 13 22 27 55" },
    email: { icon: <FaEnvelope />, address: "association.appe@yahoo.com" },
  },
  links: [
    { href: "#about", name: "Notre mission" },
    { href: "#projet-kemkian", name: "Projet Kemkian" },
    { href: "#projet-modele", name: "Projet Modelé" },
    { href: "#events", name: "Actualités" },
    { href: "#partners", name: "Partenaires" },
    { href: "#contact", name: "Contact" },
    { href: "#donate", name: "Faire un don" },
  ],
  newsletter: {
    placeholder: "Votre adresse email",
    icon: <FiSend />,
  },
};
